module.exports = __webpack_public_path__ + "img/CM-BS-24-GMC-Playful.c5962827.jpg";